import React from "react";

export const CookiePolicy = () => (
  <div className='container mg-tp-150'>
    <div className='pt-mob-4 two_column_grid pb-sm-5 pt-sm-5 pt-5 mb-mob-5 mb-sm-3 mb-md-4'>
      <div className='mb-mob-2 animated fadeInUp'>
        <div >
          <div className='col-sm-12'>
            <h1>
              Cookie Policy
            </h1>
            <p>
              We’re proud to announce we will be exhibiting at FIBO the world largest health and trade expo happening in Germany between the 2nd and 5th of April 2020 at the Exhibition Centre Cologne.

              As a leading packaging manufacturer for the fitness industry and general healthcare industry Swiss Pack is driving innovation through research and development in creating more environmentally friendly packaging solutions.

              Over the four-day FIBO exhibition in Germany Cologne, we will be showcasing our latest protein packaging, superfood packaging and new forms of eco packaging including compostable pouches, oxo-degradable pouches, and our 100% recyclable single polymer stand up pouches.

              If you’re based in Germany and want to learn more about any of our existing products or want to custom product packaging for your brand why not book in a short meeting with one of our consultants on one of the days and we’ll be happy to walk you through all details, specifications, and processes!

              Request Free Consultation
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);
